import { render, staticRenderFns } from "./TeacherItemM.vue?vue&type=template&id=c00c80d4&scoped=true"
import script from "./TeacherItemM.vue?vue&type=script&lang=ts"
export * from "./TeacherItemM.vue?vue&type=script&lang=ts"
import style0 from "./TeacherItemM.vue?vue&type=style&index=0&id=c00c80d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00c80d4",
  null
  
)

export default component.exports